// removed by extract-text-webpack-plugin
module.exports = {"css-modules-nav-example":"_12mMbi9pYZjHnytkkBkl9v","the-css-module-class":"LTvuH8RPU0mk-fe8W2tP7"};


//////////////////
// WEBPACK FOOTER
// ./example.module.css
// module id = 537
// module chunks = 0